import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import {
  delete_quote_from_id,
  edit_quote_data_from_id,
  load_quote_data_from_id,
  upload_quote,
} from "../../actions/agenda_content";
import { checkAuthenticated } from "../../actions/auth";
import PeopleSearchDropdown from "../../components/PeopleSearchDropdown2";
import { Link } from "react-router-dom";

const initialQuoteData = {
  id: "",
  professional: null,
  patient: null,
  hour: "",
  date: "",
  asistence: "pendiente",
  service: null,
  payment: "pendiente",
  payment_type: "efectivo",
  patient_evolution: null,
};
const initialEvoData = {
  evo_code: "",
  evo_detail: "",
};
const CalendarQuoteModal = (props) => {
  const dispatch = useDispatch();
  const { show, onHide, quoteId, quoteOptions } = props;
  const [quoteData, setQuoteData] = useState(initialQuoteData);
  const [patientData, setPatientData] = useState({});
  const [formAlerts, setFormAlerts] = useState({
    professional: false,
    patient: false,
    hour: false,
    date: false,
    asistence: false,
    service: false,
    payment: false,
    payment_type: false,
  });
  const [evolutionData, setEvoData] = useState({
    id: null,
    evo_code: "",
    evo_detail: "",
  });

  const [mostrarFicha, setMostrarFicha] = useState(false);

  const checkEmptyFields = (keyList, dataConst, setDataConst) => {
    let isEmpty = false;
    const newFormData = { ...dataConst };
    keyList.forEach((key) => {
      if (dataConst[key] === null || dataConst[key].toString().trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }

      setTimeout(() => {
        setFormAlerts({
          professional: false,
          patient: false,
          hour: false,
          date: false,
          asistence: false,
          service: false,
          payment: false,
          payment_type: false,
        });
      }, 3500);
    });

    setDataConst(newFormData);
    return isEmpty;
  };
  const closeModal = () => {
    setPatientData({});
    setMostrarFicha(false);
    onHide();
  };
  const handleDelete = async () => {
    dispatch(checkAuthenticated());
    await delete_quote_from_id(quoteId);

    setQuoteData(initialQuoteData);
    setEvoData(initialEvoData);
    closeModal();
  };

  const fetchQuoteData = async () => {
    dispatch(checkAuthenticated());

    const data = await load_quote_data_from_id(quoteId);
    if (data) {
      setQuoteData(data);
      if (data.patient_evolution) {
        setEvoData({
          id: data.patient_evolution.id,
          evo_code: data.patient_evolution.evo_code,
          evo_detail: data.patient_evolution.evo_detail,
        });
      } else {
        setEvoData(initialEvoData);
      }
    }
  };

  const handleSubmit = () => {
    if (
      !checkEmptyFields(
        [
          "professional",
          "patient",
          "hour",
          "date",
          "asistence",
          "service",
          "payment",
          "payment_type",
        ],
        quoteData,
        setQuoteData
      )
    ) {
      let patientEvoData = null;
      if (evolutionData.evo_detail || evolutionData.evo_code) {
        if (
          !checkEmptyFields(
            ["evo_code", "evo_detail"],
            evolutionData,
            setEvoData
          )
        ) {
          patientEvoData = {
            id: evolutionData.id,
            clinic_patient: quoteData.patient,
            evo_date: quoteData.date,
            evo_code: evolutionData.evo_code,
            evo_detail: evolutionData.evo_detail,
          };
        }
      }
      const quoteDataToUpload = {
        ...quoteData,
        patient_evolution: patientEvoData,
      };
      if (quoteId) {
        edit_quote_data_from_id(quoteId, quoteDataToUpload);
      } else {
        upload_quote(quoteDataToUpload);
      }
      closeModal();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const profs = Array.isArray(quoteOptions.professionals)
        ? quoteOptions.professionals
        : [];
      const services = Array.isArray(quoteOptions.services)
        ? quoteOptions.services
        : [];
      if (quoteId) {
        await fetchQuoteData(quoteId); // Fetch quote data only after fetchQuoteOptions finishes
      } else {
        setQuoteData({
          ...initialQuoteData,
          professional: profs.length > 0 ? profs[0].id : "",
          service: services.length > 0 ? services[0].id : "",
        });
        setEvoData(initialEvoData);
      }
    };

    fetchData();
  }, [show]);
  return (
    <Modal
      show={show}
      onHide={() => {
        closeModal();
      }}
      size={mostrarFicha ? "xl" : "md"}
      centered
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{quoteId ? "Editar Cita" : "Nueva Cita"}</Modal.Title>
        {quoteData.patient ? (
          <Button
            className="patient-detail-button ms-auto"
            onClick={(e) => setMostrarFicha(!mostrarFicha)}
          >
            <span>Resumen paciente</span>
            <i
              className={
                mostrarFicha ? "bi bi-arrow-left" : "bi bi-arrow-right"
              }
            />
          </Button>
        ) : null}
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div
            className={
              mostrarFicha
                ? "col-6"
                : "col-12" + "quote-modal-body d-flex flex-column gap-2"
            }
          >
            <div className="row">
              <div className="input-field col">
                <label
                  htmlFor="quoteHourFormControlInput"
                  className="form-label mb-1"
                >
                  Hora
                  <strong className="text-danger">*</strong>{" "}
                  <span
                    className={
                      formAlerts.hour ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="time"
                  className={
                    formAlerts.hour
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="quoteHourFormControlInput"
                  value={quoteData.hour}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, hour: e.target.value })
                  }
                />
              </div>
              <div className="input-field col">
                <label
                  htmlFor="quoteDateFormControlInput"
                  className="form-label mb-1"
                >
                  Fecha Cita
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.date ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="date"
                  className={
                    formAlerts.date
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="quoteDateFormControlInput"
                  value={quoteData.date}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, date: e.target.value })
                  }
                />
              </div>
            </div>
            <PeopleSearchDropdown
              quoteData={quoteData}
              setQuoteData={setQuoteData}
              alertPatient={formAlerts.patient}
              setPatientData={setPatientData}
            />
            <div className="input-field">
              <label
                htmlFor="addressFormControlInput"
                className="form-label mb-1"
              >
                Kinesiologo
                <strong className="text-danger">*</strong>
                <span
                  className={
                    formAlerts.professional
                      ? "fst-italic m-2 text-danger"
                      : "d-none"
                  }
                >
                  No valido.
                </span>
              </label>
              <select
                className={
                  formAlerts.professional
                    ? "border border-danger form-select"
                    : "form-select"
                }
                aria-label="Default select example"
                value={quoteData.professional}
                onChange={(e) =>
                  setQuoteData({ ...quoteData, professional: e.target.value })
                }
              >
                <option value="null">N/A</option>
                {quoteOptions.professionals?.map((professional) => (
                  <option value={professional.id} key={professional.id}>
                    {professional.name} {professional.first_lastname}{" "}
                    {professional.second_lastname} - {professional.occupation}
                  </option>
                ))}
              </select>
            </div>
            <div className="row">
              <div className="input-field col">
                <label
                  htmlFor="addressFormSelectInput"
                  className="form-label mb-1"
                >
                  Asistencia
                </label>
                <select
                  className={
                    formAlerts.asistence
                      ? "border border-danger form-select"
                      : "form-select"
                  }
                  aria-label="Default select example"
                  value={quoteData.asistence}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, asistence: e.target.value })
                  }
                >
                  <option value="pendiente">Pendiente</option>
                  <option value="confirmado">Confirmado</option>
                  <option value="cancelado">Suspendido</option>
                </select>
              </div>
              <div className="input-field col">
                <label
                  htmlFor="addressFormControlInput"
                  className="form-label mb-1"
                >
                  Servicio
                  <span
                    className={
                      formAlerts.service
                        ? "fst-italic m-2 text-danger"
                        : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <select
                  className={
                    formAlerts.service
                      ? "border border-danger form-select"
                      : "form-select"
                  }
                  aria-label="Default select example"
                  value={quoteData.service}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, service: e.target.value })
                  }
                >
                  {quoteOptions.services?.map((service) => (
                    <option value={service.id} key={service.id}>
                      {service.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="input-field col">
                <label
                  htmlFor="addressFormControlInput"
                  className="form-label mb-1"
                >
                  Pago
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={quoteData.payment}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, payment: e.target.value })
                  }
                >
                  <option value="pendiente">Pendiente</option>
                  <option value="pagado">Pagado</option>
                  <option value="cancelado">Cancelado</option>
                </select>
              </div>
              <div className="input-field col">
                <label
                  htmlFor="addressFormControlInput"
                  className="form-label mb-1"
                >
                  Tipo de Pago
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={quoteData.payment_type}
                  onChange={(e) =>
                    setQuoteData({ ...quoteData, payment_type: e.target.value })
                  }
                >
                  <option value="transferencia">Transferencia</option>
                  <option value="efectivo">Efectivo</option>
                  <option value="crédito">Crédito</option>
                </select>
              </div>
            </div>
            <div className="input-field">
              <label
                htmlFor="addressFormSelectInput"
                className="form-label mb-1"
              >
                Evolucion
              </label>
              <div className="input-group justify-content-end">
                <span className="input-group-text">Codigo</span>
                <input
                  type="text"
                  className="form-control"
                  name="evo_code"
                  value={evolutionData.evo_code}
                  onChange={(e) =>
                    setEvoData({ ...evolutionData, evo_code: e.target.value })
                  }
                />
                <div className="input-group">
                  <span className="input-group-text rounded-0">Detalle</span>
                  <textarea
                    className="form-control rounded-0"
                    name="evo_detail"
                    value={evolutionData.evo_detail}
                    onChange={(e) =>
                      setEvoData({
                        ...evolutionData,
                        evo_detail: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {mostrarFicha && patientData && (
            <div className="col-6 quote-modal-ficha d-flex flex-column gap-2">
              <div className="d-flex justify-content-between px-2">
                <h6 className="mb-0">Ficha Kinésica</h6>
                <h6 className="mb-0">N° Ficha: {quoteData.patient}</h6>
              </div>

              <div className="row">
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Fecha registro
                  </span>
                  <input
                    type="text"
                    value={patientData.created}
                    className="form-control"
                    disabled
                  />
                </div>

                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Fecha cita med.
                  </span>
                  <input
                    type="text"
                    value={
                      patientData.health_info.medical_quote_date
                        ? patientData.health_info.medical_quote_date
                        : "N/A"
                    }
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  Nombre Completo
                </span>
                <input
                  type="text"
                  value={`${patientData.name} ${patientData.first_lastname} ${
                    patientData.second_lastname
                      ? patientData.second_lastname
                      : ""
                  }`}
                  className="form-control"
                  disabled
                />
              </div>
              <div className="row">
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Rut
                  </span>
                  <input
                    type="text"
                    value={patientData.rut}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Nacionalidad
                  </span>
                  <input
                    type="text"
                    value={patientData.country}
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Nacimiento
                  </span>
                  <input
                    type="text"
                    value={patientData.birthday}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Edad
                  </span>
                  <input
                    type="text"
                    value={patientData.age}
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Teléfono
                  </span>
                  <input
                    type="text"
                    value={patientData.phone}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Previsión
                  </span>
                  <input
                    type="text"
                    value={patientData.prevision}
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Ocupación
                  </span>
                  <input
                    type="text"
                    value={patientData.ocupation}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="input-group col">
                  <span className="input-group-text" id="basic-addon1">
                    Sexo
                  </span>
                  <input
                    type="text"
                    value={patientData.sex}
                    className="form-control"
                    disabled
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  Kinesiologo Asignado
                </span>
                <input
                  type="text"
                  value={
                    patientData.health_info
                      ? patientData.health_info.professional_name
                      : "Ninguno"
                  }
                  className="form-control"
                  disabled
                />
              </div>
              <div className="input-group">
                <span className="input-group-text">Anamnesis</span>
                <textarea
                  className="form-control"
                  value={patientData.health_info.anamnesis}
                  disabled
                />
              </div>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  Nombre doctor
                </span>
                <input
                  type="text"
                  value={patientData.health_info.doctors_name}
                  className="form-control"
                  disabled
                />
              </div>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  Diagnostico
                </span>
                <input
                  type="text"
                  value={patientData.health_info.diagnosis}
                  className="form-control"
                  disabled
                />
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        {quoteId && (
          <Button variant="danger" onClick={handleDelete}>
            Eliminar
          </Button>
        )}
        {quoteData.patient && (
          <Link
            to={`/paciente/${quoteData.patient}`}
            className="patient-detail-button btn btn-success ms-auto"
          >
            <span>Ver paciente</span>
            {/* <i className="bi bi-person-circle" /> */}
          </Link>
        )}
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button
            variant="secondary"
            onClick={() => {
              closeModal();
            }}
          >
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Guardar Cambios
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CalendarQuoteModal;
